module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Smart_Speakers.8cab5ed9.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Smart_Speakers.svg
// module id = 3548
// module chunks = 0